export default __webpack_public_path__ + "locales/zh-CN/DownloadDialog.json?hash=f1330772f68e3e688b13aa2d3333a3c0";